import { config, appFetch } from './appFetch';

export const findAllProvinces = (language, onSuccess, onErrors) => {
    appFetch('/location/provinces/', config('GET', null, language), onSuccess, onErrors);
}

export const findAllMunicipalitiesByProvince = (provinceCode, language, onSuccess, onErrors) => {
    appFetch(`/location/municipality?provinceCode=${provinceCode}`, config('GET', null, language), onSuccess, onErrors);
}

export const findAllParishesByMunicipality = (provinceCode, municipalityCode, language, onSuccess, onErrors) => {
    appFetch(`/location/parish?provinceCode=${provinceCode}&municipalityCode=${municipalityCode}`, config('GET', null, language), onSuccess, onErrors);
}